
import React, { useState, useEffect, useRef, useMemo } from 'react';
import { Car, CarRequest } from '../types';
import { MapPin, Search, Star, PlusCircle, CheckCircle2, XCircle, Navigation, ShieldAlert, Car as CarIcon, LocateFixed, Loader2, HelpCircle, Sparkles, ExternalLink, MapPlus, Database, Eye, EyeOff, Trash2, Edit, Plus, Minus, Maximize, Utensils, Bath, ParkingSquare, Fuel, Coffee, Info, Check, CornerDownLeft, Store, Globe, ChevronDown, ChevronUp } from 'lucide-react';
import * as L from 'leaflet';
import { searchPlacesWithMaps } from '../services/geminiService';
import { supabase } from '../supabaseClient';
import { XP_VALUES, rewardUserByEmail, awardOnce } from '../services/gamificationService';

interface Props {
  userEmail: string | undefined;
  isAdmin: boolean;
}

export const INITIAL_FLEET: Car[] = [
  { placa: "TIW 7A01", modelo: "Song Plus", endereco: "Rua São Caetano - Luz", lat: -23.5365, lon: -46.6332 },
  { placa: "TJL 0G63", modelo: "Song Plus", endereco: "Rua Doutor Melo Alves - Cerqueira Cezar", lat: -23.5593, lon: -46.6667 },
  { placa: "TMC 6A94", modelo: "Song Plus", endereco: "Rua Tamoios - Jardim Aeroporto", lat: -23.6264, lon: -46.6631 },
  { placa: "TLM 9B83", modelo: "Song Plus", endereco: "Rua Felix de Sousa - Vila Congonhas", lat: -23.6258, lon: -46.6575 },
  { placa: "TJX 7G21", modelo: "Song Plus", endereco: "Rua Engenheiro Mesquita Sampaio - Vila São Francisco", lat: -23.6333, lon: -46.7111 },
  { placa: "STS 8J83", modelo: "Song Plus", endereco: "Rua Moacir Piza - Cerqueira César", lat: -23.5578, lon: -46.6669 },
  { placa: "TLB 9C11", modelo: "Song Plus", endereco: "Rua Silvia - Bela Vista", lat: -23.5644, lon: -46.6522 },
  { placa: "TLA 2D97", modelo: "Song Plus", endereco: "Rua Sarandi - Cerqueira César", lat: -23.5611, lon: -46.6656 },
  { placa: "TIZ 3I46", modelo: "Song Plus", endereco: "Alameda Sarutaiá - Jardim Paulista", lat: -23.5714, lon: -46.6558 },
  { placa: "TLF 7J97", modelo: "Song Plus", endereco: "Rua Juquis - Moema", lat: -23.6067, lon: -46.6622 },
  { placa: "TLV 9C85", modelo: "Song Plus", endereco: "Rua Alvaro Luis Roberto de Assunção - Campo Belo", lat: -23.6217, lon: -46.6789 },
  { placa: "TLB 0I37", modelo: "Song Plus", endereco: "Rua Grapecica - Brooklin", lat: -23.6083, lon: -46.6903 },
  { placa: "TJA 5J34", modelo: "Song Plus", endereco: "Rua da Mata - Itaim Bibi", lat: -23.5853, lon: -46.6783 },
  { placa: "SVJ 5I68", modelo: "Song Plus", endereco: "Rua Silvania - Vila Nova Conceição", lat: -23.5933, lon: -46.6711 },
  { placa: "TLO 1J77", modelo: "Song Plus", endereco: "Rua Andiroba - Brooklin", lat: -23.6156, lon: -46.6917 },
  { placa: "SWW 7G55", modelo: "Song Plus", endereco: "Rua Horacio Lane - Pinheiros", lat: -23.5619, lon: -46.6983 },
  { placa: "SWA 8F65", modelo: "Song Plus", endereco: "Rua Afonso de Freitas - Paraiso", lat: -23.5767, lon: -46.6433 },
  { placa: "SVV 2C58", modelo: "Song Plus", endereco: "Rua Professor Paulo Pupo - Jardim Leonor", lat: -23.6014, lon: -46.7117 },
  { placa: "SWZ 1A71", modelo: "Song Plus", endereco: "Rua Capitã Messias - Perdizes", lat: -23.5350, lon: -46.6806 },
  { placa: "TMC 8C66", modelo: "Song Plus", endereco: "Rua Otávio Tarquínio de Sousa, 377 - Campo Belo", lat: -23.6253, lon: -46.6717 },
  { placa: "SVR 2F25", modelo: "Song Plus", endereco: "Rua Queluz - Jardim Paulista", lat: -23.5700, lon: -46.6625 },
  { placa: "STU 9G54", modelo: "Song Plus", endereco: "Rua Jose Tavares de Miranda - Pompeia", lat: -23.5311, lon: -46.6844 },
  { placa: "STL 1B18", modelo: "Song Plus", endereco: "Praça Pereira Coutinho - Vila Nova Conceição", lat: -23.5947, lon: -46.6675 },
  { placa: "SWL 5B92", modelo: "Song Plus", endereco: "Rua Cardineus - Indianopolis", lat: -23.6064, lon: -46.6748 },
  { placa: "SVA 3A83", modelo: "Song Plus", endereco: "Rua Beira Rio - Vila Olimpia", lat: -23.5975, lon: -46.6847 },
  { placa: "GEO 8I72", modelo: "Song Plus", endereco: "Rua Viradouro - Itaim Bibi", lat: -23.5828, lon: -46.6761 },
  { placa: "SUW 2G53", modelo: "Song Plus", endereco: "Rua Filipe de Alcaçova - Pinheiros", lat: -23.5583, lon: -46.7028 },
  { placa: "SVQ 4F23", modelo: "Song Plus", endereco: "Rua Salvador Cardoso - Itaim Bibi", lat: -23.5861, lon: -46.6772 },
  { placa: "STR 4F56", modelo: "Song Plus", endereco: "Rua Antonio da Costa Barbosa - Vila Andrade", lat: -23.6339, lon: -46.7333 },
  { placa: "STH 1F46", modelo: "Song Plus", endereco: "Rua Doutor Flado Haidar - Vila Olimpia", lat: -23.5936, lon: -46.6811 },
  { placa: "SVS 8F66", modelo: "Song Plus", endereco: "Rua Coronel Joaquim Ferreira Lobo - Itaim Bibi", lat: -23.5881, lon: -46.6764 },
  { placa: "SWZ 8H37", modelo: "Song Plus", endereco: "Praça General San Martin - Jardim America", lat: -23.5722, lon: -46.6733 },
  { placa: "STO 7G58", modelo: "Song Plus", endereco: "Rua Major Quedinho - Bela Vista", lat: -23.5511, lon: -46.6433 },
  { placa: "SWQ 1C75", modelo: "Song Plus", endereco: "Praça Guilherme Kawall - Pinheiros", lat: -23.5658, lon: -46.6983 },
  { placa: "SVP 3B48", modelo: "Song Plus", endereco: "Rua Guaninas - Jardim Aeroporto", lat: -23.6269, lon: -46.6639 },
  { placa: "TKT 3G36", modelo: "Song Plus", endereco: "Avenida Ibijaú - Moema", lat: -23.6061, lon: -46.6661 },
  { placa: "TKF 4F42", modelo: "Song Plus", endereco: "Rua Carmontelle - Vila Olímpia", lat: -23.5944, lon: -46.6861 },
  { placa: "TKU 0F04", modelo: "Song Plus", endereco: "Rua Urussuí - Itaim Bibi", lat: -23.5833, lon: -46.6750 },
  { placa: "TIW 7I95", modelo: "Song Plus", endereco: "Rua André Fernandes - Itaim Bibi", lat: -23.5869, lon: -46.6778 },
  { placa: "SUZ 1J93", modelo: "Song Plus", endereco: "Rua Luís Coelho - Consolação", lat: -23.5561, lon: -46.6550 },
  { placa: "TKH 7E87", modelo: "Song Plus", endereco: "Rua Chabad - Cerqueira Cesar", lat: -23.5636, lon: -46.6650 },
  { placa: "TJF 8D71", modelo: "Song Plus", endereco: "Rua Itarare - Bela Vista", lat: -23.5539, lon: -46.6506 },
  { placa: "TLN 5H19", modelo: "Song Plus", endereco: "Rua Epitacio Pessoa - República", lat: -23.5453, lon: -46.6439 },
  { placa: "TJI 8F75", modelo: "Song Plus", endereco: "Rua Madre Cabrini - Vila Mariana", lat: -23.5856, lon: -46.6383 },
  { placa: "TJB 2C74", modelo: "Song Plus", endereco: "Rua Leôncio de Carvalho - Paraíso", lat: -23.5711, lon: -46.6467 },
  { placa: "TJC 6G88", modelo: "Song Plus", endereco: "Estrada Carlos Queiroz Telles - Jardim Fonte do Morumbi", lat: -23.6167, lon: -46.7278 },
  { placa: "TLM 8E10", modelo: "Song Plus", endereco: "Rua Coronel Luís Tenório de Brito - Jardim Leonor", lat: -23.6022, lon: -46.7122 },
  { placa: "TKN 6I57", modelo: "Song Plus", endereco: "Praça Senador Lineu Prestes - Pinheiros", lat: -23.5583, lon: -46.6958 },
  { placa: "TJE 6J50", modelo: "Song Plus", endereco: "Praça Arlindo Rossi - Brooklin", lat: -23.6089, lon: -46.6917 },
  { placa: "SVP 2J45", modelo: "Song Plus", endereco: "Rua Maringá - Pompéia", lat: -23.5283, lon: -46.6833 },
  { placa: "TLR 6J59", modelo: "Song Plus", endereco: "Rua Bugio - Vila Olímpia", lat: -23.5950, lon: -46.6850 },
  { placa: "TIY 7B43", modelo: "Song Plus", endereco: "Rua Gararu - Vila Nova Conceição", lat: -23.5917, lon: -46.6717 },
  { placa: "TLB 2H99", modelo: "Song Plus", endereco: "Rua Cravinhos - Jardim Paulista", lat: -23.5706, lon: -46.6567 },
  { placa: "TJA 8E57", modelo: "Song Plus", endereco: "Rua Anacetuba - Itaim Bibi", lat: -23.5822, lon: -46.6778 },
  { placa: "TKM 2I07", modelo: "Song Plus", endereco: "Rua Tatuí - Jd. Paulista", lat: -23.5683, lon: -46.6583 },
  { placa: "TIP 5J79", modelo: "Song Plus", endereco: "Rua Antilhas - Jd. Paulista", lat: -23.5700, lon: -46.6600 },
  { placa: "STI 8B66", modelo: "Song Plus", endereco: "Rua Goitacás - Santa Cecilia", lat: -23.5367, lon: -46.6500 },
  { placa: "TKJ 7I55", modelo: "Song Plus", endereco: "Rua Chilon - Vila Olímpia", lat: -23.5967, lon: -46.6867 },
  { placa: "TKG 9I68", modelo: "Song Plus", endereco: "Rua Said Aiach - Paraiso", lat: -23.5767, lon: -46.6467 },
  { placa: "TIS 9A52", modelo: "Song Plus", endereco: "Rua Engenheiro Agenor Machado - Santo Amaro", lat: -23.6444, lon: -46.6917 },
  { placa: "TKY 1H48", modelo: "Song Plus", endereco: "Rua Mirassol - Vila Clementino", lat: -23.5983, lon: -46.6467 },
  { placa: "TJQ 4F63", modelo: "Song Plus", endereco: "Rua Prof. Carlos de Carvalho - Itaim Bibi", lat: -23.5850, lon: -46.6750 },
  { placa: "TJU 1J44", modelo: "Song Plus", endereco: "Rua Honório Líbero - Pinheiros", lat: -23.5539, lon: -46.7011 },
  { placa: "GDJ 5F31", modelo: "Song Plus", endereco: "Rua Dona Elisa - Barra Funda", lat: -23.5261, lon: -46.6583 },
  { placa: "SUT 0B16", modelo: "Song Plus", endereco: "Rua Gravataí - Consolação", lat: -23.5489, lon: -46.6472 },
  { placa: "TKN 1G42", modelo: "Song Plus", endereco: "Rua Iara - Itaim Bibi", lat: -23.5817, lon: -46.6767 },
  { placa: "TKI 6F25", modelo: "Song Plus", endereco: "Praça Coronel Pires de Andrade - Pinheiros", lat: -23.5617, lon: -46.7000 },
  { placa: "SUR 2H78", modelo: "Song Plus", endereco: "Rua do Emissário - Pinheiros", lat: -23.5650, lon: -46.7033 },
  { placa: "STJ 3H52", modelo: "Song Plus", endereco: "Rua Mairinque - Vila Clementino", lat: -23.5989, lon: -46.6483 }
];

// Initial POIs (Hardcoded defaults)
const DEFAULT_POIS = [
  {
    name: "Posto Credenciado",
    address: "Alameda Lorena, 1106 (esq. Peixoto Gomide)",
    lat: -23.5625,
    lon: -46.6655,
    type: "FUEL",
    message: "Abastecer aqui se autonomia < 399km"
  },
  {
    name: "Garagem Central",
    address: "Alameda Jaú, 850",
    lat: -23.5645,
    lon: -46.6525,
    type: "GARAGE",
    message: "Local de devolução do veículo"
  },
  {
    name: "Shopping JK Iguatemi",
    address: "Av. Pres. Juscelino Kubitschek, 2041",
    lat: -23.5912,
    lon: -46.6908,
    type: "BATHROOM",
    message: "Banheiros femininos limpos e seguros no 2º andar."
  },
  {
    name: "Shopping Vila Olímpia",
    address: "R. Olimpíadas, 360",
    lat: -23.5956,
    lon: -46.6873,
    type: "BATHROOM",
    message: "Fácil acesso, limpo e seguro."
  },
  {
    name: "Estação de Serviço - Bandeira",
    address: "Av. dos Bandeirantes, 3000",
    lat: -23.6085,
    lon: -46.6668,
    type: "BATHROOM",
    message: "Banheiro reformado e gratuito para motoristas."
  },
  {
    name: "Sesc Pinheiros (Almoço)",
    address: "R. Paes Leme, 195",
    lat: -23.5684,
    lon: -46.6997,
    type: "FOOD",
    message: "Comidaria com preço acessível e qualidade excelente."
  },
  {
    name: "Prato Feito da Dona Ana",
    address: "R. Tabapuã, 1450 (Próximo)",
    lat: -23.5852,
    lon: -46.6795,
    type: "FOOD",
    message: "PF caprichado por R$ 25,00. Serve rápido."
  },
  {
    name: "Recuo Vila Olímpia",
    address: "Rua Funchal (Lateral)",
    lat: -23.5925,
    lon: -46.6890,
    type: "NO_ZONA_AZUL",
    message: "Pequeno recuo onde é possível parar rapidinho sem zona azul."
  },
  {
    name: "Rua Sem Saída - Itaim",
    address: "Travessa próxima à JK",
    lat: -23.5880,
    lon: -46.6750,
    type: "NO_ZONA_AZUL",
    message: "Rua tranquila para aguardar chamadas, sem fiscalização intensa."
  }
];

// Combine types
type PoiType = 'FUEL' | 'GARAGE' | 'BATHROOM' | 'FOOD' | 'NO_ZONA_AZUL';

// Mini Map Component for Admin Preview
const MiniMapPreview: React.FC<{ lat: number; lon: number }> = ({ lat, lon }) => {
    const mapRef = useRef<HTMLDivElement>(null);
    const mapInstance = useRef<L.Map | null>(null);

    useEffect(() => {
        if (!mapRef.current) return;

        // Cleanup existing map if props change
        if (mapInstance.current) {
            mapInstance.current.remove();
            mapInstance.current = null;
        }

        const map = L.map(mapRef.current, {
            center: [lat, lon],
            zoom: 16,
            zoomControl: false,
            dragging: false,
            scrollWheelZoom: false,
            doubleClickZoom: false,
            boxZoom: false,
            attributionControl: false
        });

        L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            subdomains: 'abcd',
            maxZoom: 20
        }).addTo(map);

        L.circleMarker([lat, lon], {
            radius: 6,
            fillColor: '#f97316',
            color: '#fff',
            weight: 2,
            opacity: 1,
            fillOpacity: 1
        }).addTo(map);

        mapInstance.current = map;

        return () => {
            if (mapInstance.current) {
                mapInstance.current.remove();
                mapInstance.current = null;
            }
        };
    }, [lat, lon]);

    return <div ref={mapRef} className="w-full h-32 rounded-lg border border-slate-700 bg-slate-800" />;
};

export const FleetView: React.FC<Props> = ({ userEmail, isAdmin }) => {
  const [activeTab, setActiveTab] = useState<'MAP' | 'SUGGEST' | 'ADMIN' | 'AI_SEARCH'>('MAP');
  const [fleet, setFleet] = useState<Car[]>([]); // All approved items (Cars + POIs)
  const [pendingRequests, setPendingRequests] = useState<CarRequest[]>([]); // Requests from DB
  const [dbError, setDbError] = useState<string | null>(null);
  
  // Favorites State with Loading
  const [favorites, setFavorites] = useState<string[]>([]);
  const [loadingFavorites, setLoadingFavorites] = useState(false);
  
  // Marker Visibility States
  const [showVehicles, setShowVehicles] = useState(true);
  const [isVehicleListOpen, setIsVehicleListOpen] = useState(false);
  
  // POI Filter State
  const [activePoiFilter, setActivePoiFilter] = useState<'ALL' | PoiType>('ALL');

  // Search State with Debounce
  const [searchTerm, setSearchTerm] = useState(''); // The effective term used for filtering
  const [searchInput, setSearchInput] = useState(''); // The immediate input value
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  
  // Confirmation Modal State
  const [isConfirming, setIsConfirming] = useState(false);
  const [isSending, setIsSending] = useState(false); // New state for loading during submit
  const [carToDelete, setCarToDelete] = useState<Car | null>(null);
  
  // Edit Location State (Admin) & Admin Edit Request
  const [carToEdit, setCarToEdit] = useState<Car | null>(null);
  const [requestToEdit, setRequestToEdit] = useState<CarRequest | null>(null); // For admin editing requests
  const [editAddress, setEditAddress] = useState('');
  const [isUpdatingLocation, setIsUpdatingLocation] = useState(false);

  // Suggestion Flow
  const [isPickingLocation, setIsPickingLocation] = useState(false);

  // Geolocation states
  const [isLocating, setIsLocating] = useState(false);
  const [geoError, setGeoError] = useState<string | null>(null);

  // AI Search State
  const [aiQuery, setAiQuery] = useState('');
  const [aiResult, setAiResult] = useState<{ text: string, grounding: any[] } | null>(null);
  const [aiLoading, setAiLoading] = useState(false);
  const [aiError, setAiError] = useState<string | null>(null);
  
  // Map References
  const mapRef = useRef<L.Map | null>(null);
  const markersRef = useRef<L.LayerGroup | null>(null);
  const mapContainerRef = useRef<HTMLDivElement>(null);
  const userLocationMarkerRef = useRef<L.Marker | null>(null);

  // NEW: Pending FlyTo State to handle tab switching race condition
  const [pendingFlyTo, setPendingFlyTo] = useState<{ lat: number, lon: number } | null>(null);

  // Suggestion Form State - Expanded for POI types
  const [suggestForm, setSuggestForm] = useState<{
    type: 'VEHICLE' | PoiType;
    placa: string;
    modelo: string;
    endereco: string;
    lat: number;
    lon: number;
    description: string;
  }>({
    type: 'VEHICLE',
    placa: '',
    modelo: '',
    endereco: '',
    lat: 0,
    lon: 0,
    description: ''
  });

  // GPS Mapeamento state
  const [isGpsMapping, setIsGpsMapping] = useState(false);
  const [gpsDetectedAddress, setGpsDetectedAddress] = useState<string | null>(null);
  const [gpsCoords, setGpsCoords] = useState<{ lat: number; lon: number } | null>(null);
  const [showGpsConfirm, setShowGpsConfirm] = useState(false);

  // ── Formatador de Placa: maiúsculas + espaço após 3º dígito (ex: UDE 5J87)
  const formatPlate = (raw: string): string => {
    const upper = raw.toUpperCase().replace(/[^A-Z0-9]/g, '');
    if (upper.length <= 3) return upper;
    return upper.slice(0, 3) + ' ' + upper.slice(3, 7);
  };

  // ── Simplificador de Endereço: remove CEPs, números e "Brasil", mantém Rua · Bairro · Cidade
  // Regra SP: Se cidade = São Paulo → substitui por "SP"
  const simplifyAddress = (raw: string): string => {
    if (!raw) return '';
    // Remove CEP (ex: 01310-100 ou 01310100)
    let s = raw.replace(/\b\d{5}-?\d{3}\b/g, '');
    // Remove "Brasil" (case-insensitive)
    s = s.replace(/,?\s*Brasil\b/gi, '');
    // Remove "São Paulo" estado (quando vem depois da cidade) ex: ", São Paulo, SP"
    s = s.replace(/,\s*São Paulo,\s*SP/gi, ', SP');
    // remove número isolado de rua ex: "Rua Foo, 123," → "Rua Foo,"
    s = s.replace(/,\s*\d+\s*(?=[,]|$)/g, '');
    // Limpar vírgulas duplas e espaços extras
    s = s.replace(/,\s*,/g, ',').replace(/\s+/g, ' ').trim().replace(/,\s*$/, '');
    // Pegar apenas até 3 partes: Rua, Bairro, Cidade
    const parts = s.split(',').map(p => p.trim()).filter(Boolean).slice(0, 3);
    // Substituir "São Paulo" pela sigla SP
    const result = parts.map(p => p.replace(/^São Paulo$/i, 'SP')).join(' · ');
    return result;
  };

  // ── Helper Badge Fresh (Últimas 24h)
  const isFresh = (dateString?: string) => {
      if (!dateString) return false;
      const then = new Date(dateString).getTime();
      return (Date.now() - then) < 24 * 60 * 60 * 1000;
  };

  // Helper to distinguish Real Cars from Approved POIs based on ID convention
  const isApprovedPoi = (item: Car) => item.placa.startsWith('POI-');

  // Separation of Fleet vs POIs (both from fleet table)
  const realCars = useMemo(() => fleet.filter(c => !isApprovedPoi(c)), [fleet]);
  const approvedPoisFromDb = useMemo(() => fleet.filter(c => isApprovedPoi(c)), [fleet]);

  // Derived POIs: Default + Approved from DB
  const allPointsOfInterest = useMemo(() => {
    // Map DB POIs to Map Format
    const mappedDbPois = approvedPoisFromDb.map(poi => {
        // Parse "TYPE: Name" from modelo field
        let type: PoiType = 'FUEL';
        let name = poi.modelo;
        
        if (poi.modelo.includes(':')) {
            const parts = poi.modelo.split(':');
            const typeStr = parts[0].trim();
            name = parts.slice(1).join(':').trim();
            
            if (['FOOD', 'BATHROOM', 'NO_ZONA_AZUL', 'GARAGE', 'FUEL'].includes(typeStr)) {
                type = typeStr as PoiType;
            }
        }

        return {
            name: name,
            address: poi.endereco,
            lat: poi.lat,
            lon: poi.lon,
            type: type,
            message: "Local verificado e aprovado pela gestão.",
            isPending: false,
            created_at: poi.created_at
        };
    });

    return [...DEFAULT_POIS, ...mappedDbPois];
  }, [approvedPoisFromDb]);

  // Filter Logic for Real Cars
  const filteredFleet = useMemo(() => {
    const searchLower = searchTerm.toLowerCase();
    const searchNoSpaces = searchLower.replace(/\s+/g, '');

    return realCars.filter(c => {
      const placaNoSpaces = c.placa.toLowerCase().replace(/\s+/g, '');
      return placaNoSpaces.includes(searchNoSpaces) || 
             c.modelo.toLowerCase().includes(searchLower) ||
             c.endereco.toLowerCase().includes(searchLower);
    });
  }, [realCars, searchTerm]);

  // Debounce Logic for Search
  useEffect(() => {
    const handler = setTimeout(() => {
        setSearchTerm(searchInput);
    }, 300); // Wait 300ms after last keystroke

    return () => {
        clearTimeout(handler);
    };
  }, [searchInput]);

  // Load data from Supabase on mount
  useEffect(() => {
    const fetchFleet = async () => {
      try {
        const { data: fleetData, error: fleetError } = await supabase.from('fleet_cars').select('*');
        
        if (fleetError) {
             if (fleetError.code === '42P01') {
                 setDbError('As tabelas do banco de dados ainda não foram criadas.');
             } else {
                 console.error('Error fetching fleet:', fleetError);
             }
             setFleet(INITIAL_FLEET); 
             return;
        }

        if (fleetData && fleetData.length > 0) {
            setFleet(fleetData);
            setDbError(null);
        } else {
            setFleet(INITIAL_FLEET);
        }

        const { data: pendingData } = await supabase.from('fleet_requests').select('*').eq('status', 'pending');
        if (pendingData) setPendingRequests(pendingData);

      } catch (err) {
        console.error("Unexpected error loading fleet:", err);
      }
    };

    fetchFleet();
  }, []);

  // Fetch Favorites from Supabase
  useEffect(() => {
    const fetchFavorites = async () => {
        if (!userEmail) return;
        setLoadingFavorites(true);
        
        const { data, error } = await supabase
            .from('user_favorites')
            .select('plate')
            .eq('user_email', userEmail);

        if (error) {
            console.error('Error fetching favorites:', error);
        } else if (data) {
            setFavorites(data.map((item: any) => item.plate));
        }
        setLoadingFavorites(false);
    };

    fetchFavorites();
  }, [userEmail]);

  const toggleFavorite = async (placa: string) => {
    if (!userEmail) return;

    const { data: { user } } = await supabase.auth.getUser();
    if (!user) {
        console.error("Usuário deslogado!");
        return;
    }

    const isFavorited = favorites.includes(placa);
    
    if (!isFavorited && favorites.length >= 3) {
        alert("Você só pode ter 3 favoritos.");
        return;
    }

    let newFavs = [...favorites];
    if (isFavorited) {
        newFavs = newFavs.filter(p => p !== placa);
    } else {
        newFavs.push(placa);
    }
    setFavorites(newFavs);

    try {
        if (isFavorited) {
            const { error } = await supabase
                .from('user_favorites')
                .delete()
                .eq('user_email', userEmail)
                .eq('plate', placa);
            
            if (error) throw error;
        } else {
            const { error } = await supabase
                .from('user_favorites')
                .insert({ user_email: userEmail, plate: placa });
                
            if (error) throw error;

            // Award 10 XP once per car favorited
            awardOnce(user.id, `fav_car_${placa}`, XP_VALUES.FAVORITE_CAR);
        }
    } catch (err) {
        console.error("Failed to update favorite in DB", err);
        const { data } = await supabase.from('user_favorites').select('plate').eq('user_email', userEmail);
        if (data) setFavorites(data.map((item: any) => item.plate));
    }
  };

  // --- MAP INIT EFFECT ---
  useEffect(() => {
    // We want the map to be available in MAP or SUGGEST mode (if picking location)
    const shouldShowMap = activeTab === 'MAP' || (activeTab === 'SUGGEST' && isPickingLocation);

    if (shouldShowMap && mapContainerRef.current && !mapRef.current) {
      const map = L.map(mapContainerRef.current, {
          zoomControl: false,
          attributionControl: true
      }).setView([-23.5505, -46.6333], 15);
      
      L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
        attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/attributions">CARTO</a>',
        subdomains: 'abcd',
        maxZoom: 20
      }).addTo(map);

      mapRef.current = map;
      markersRef.current = L.layerGroup().addTo(map);

      // Check for pending flyTo operation
      if (pendingFlyTo) {
          map.flyTo([pendingFlyTo.lat, pendingFlyTo.lon], 16, { duration: 1.5 });
          setPendingFlyTo(null); // Clear pending
      }

      // --- CLICK HANDLER FOR PICKING LOCATION ---
      map.on('click', async (e: L.LeafletMouseEvent) => {
          if (activeTab === 'SUGGEST' && isPickingLocation) {
              const { lat, lng } = e.latlng;
              
              // 1. Update Form with Coordinates Immediately
              setSuggestForm(prev => ({ ...prev, lat, lon: lng }));
              
              // 2. Add temporary marker to show selection
              if (markersRef.current) {
                  markersRef.current.clearLayers();
                  const marker = L.marker([lat, lng]).addTo(markersRef.current);
                  marker.bindPopup("Local Selecionado").openPopup();
              }

              // 3. Reverse Geocode (Optional but good UX)
              try {
                  const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${lat}&lon=${lng}`, {
                      headers: { 'User-Agent': 'DriverScoreApp' }
                  });
                  const data = await response.json();
                  if (data && data.display_name) {
                      setSuggestForm(prev => ({ ...prev, endereco: data.display_name }));
                  }
              } catch (err) {
                  console.error("Reverse geocoding failed", err);
              }

              // 4. Return to Form after brief delay
              setTimeout(() => {
                  setIsPickingLocation(false);
              }, 800);
          }
      });
    }

    return () => {
       if (mapRef.current && !shouldShowMap) {
         mapRef.current.remove();
         mapRef.current = null;
         markersRef.current = null;
       }
    };
  }, [activeTab, isPickingLocation, pendingFlyTo]);

  // --- AUTO ZOOM ON FILTER CHANGE EFFECT ---
  useEffect(() => {
    if (!mapRef.current || !activePoiFilter || isPickingLocation) return;

    if (activePoiFilter !== 'ALL') {
        const visiblePois = allPointsOfInterest.filter(p => p.type === activePoiFilter);
        
        if (visiblePois.length > 0) {
            const bounds = L.latLngBounds(visiblePois.map(p => [p.lat, p.lon]));
            mapRef.current.fitBounds(bounds, { padding: [50, 50], maxZoom: 15, animate: true, duration: 1.0 });
        }
    } else {
        if (filteredFleet.length > 0) {
             const bounds = L.latLngBounds(filteredFleet.map(c => [c.lat, c.lon]));
             mapRef.current.fitBounds(bounds, { padding: [50, 50] });
        }
    }
  }, [activePoiFilter, filteredFleet, allPointsOfInterest, isPickingLocation]);


  // --- MAP MARKERS UPDATE EFFECT ---
  useEffect(() => {
    if (mapRef.current && markersRef.current && !isPickingLocation) {
      const markersLayer = markersRef.current;
      markersLayer.clearLayers();

      // 1. Add Fleet Markers (Cars)
      if (showVehicles) {
        filteredFleet.forEach(car => {
            const isFav = favorites.includes(car.placa);
            // NEW: Standard cars are Black (#000000/slate-950), Favorites are Yellow/Gold
            const bgColor = isFav ? '#EAB308' : '#0f172a'; 
            const borderColor = '#ffffff';
            const size = isFav ? 50 : 36; // Slightly larger for visibility
            const zIndexOffset = isFav ? 10000 : 100;

            const iconContent = isFav 
                ? `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="#fff" stroke="none"><polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2"/></svg>` 
                : `<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M2 12h12"/></svg>`;

            const iconHtml = `
            <div style="
                background-color: ${bgColor};
                width: ${size}px;
                height: ${size}px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                border: ${isFav ? '3px' : '2px'} solid ${borderColor};
                box-shadow: ${isFav ? '0 0 20px rgba(234, 179, 8, 0.8)' : '0 4px 10px rgba(0,0,0,0.5)'};
                transform: ${isFav ? 'scale(1.1)' : 'scale(1)'};
                transition: all 0.2s ease-out;
            ">
                ${iconContent}
            </div>
            `;

            const customIcon = L.divIcon({
                html: iconHtml,
                className: 'custom-car-marker',
                iconSize: [size, size],
                iconAnchor: [size/2, size/2],
                popupAnchor: [0, -size/2]
            });

            const marker = L.marker([car.lat, car.lon], { 
                icon: customIcon,
                zIndexOffset: zIndexOffset
            });
            
            const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${car.lat},${car.lon}`;

            const popupContent = `
              <div style="font-family: 'Inter', sans-serif; color: #0f172a; min-width: 220px; padding: 4px;">
                  <div style="display:flex; justify-content:space-between; align-items:flex-start; margin-bottom: 8px;">
                       <div style="display:flex; flex-direction:column; gap: 4px;">
                           <strong style="font-size: 16px; color: #1e293b; display: flex; align-items: center; gap: 4px;">
                             ${car.modelo}
                             ${isFresh(car.created_at) ? '<span style="background-color: #10b981; color: white; padding: 2px 4px; border-radius: 4px; font-size: 10px; font-weight: bold; line-height: 1;">NOVO</span>' : ''}
                           </strong>
                           <span style="
                              background-color: #0f172a; 
                              color: #fff; 
                              padding: 4px 8px; 
                              border-radius: 4px; 
                              font-size: 12px; 
                              font-weight: 600; 
                              letter-spacing: 0.5px;
                              display: inline-block;
                              box-shadow: 0 1px 2px rgba(0,0,0,0.1);
                           ">${car.placa}</span>
                       </div>
                       ${isFav ? '<span style="color:#eab308; font-size: 18px; line-height: 1;">★</span>' : ''}
                  </div>
                  <div style="display: flex; align-items: flex-start; gap: 6px; margin-bottom: 8px;">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="#64748b" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="margin-top: 2px; flex-shrink: 0;"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>
                      <p style="font-size: 13px; line-height: 1.4; color: #334155; margin: 0;">${car.endereco}</p>
                  </div>
                  <a href="${mapsUrl}" target="_blank" rel="noopener noreferrer" style="
                      display: flex;
                      align-items: center;
                      justify-content: center;
                      gap: 6px;
                      background-color: #0f172a;
                      color: white;
                      text-decoration: none;
                      padding: 10px;
                      border-radius: 8px;
                      font-size: 13px;
                      font-weight: 600;
                      text-align: center;
                      transition: background-color 0.2s;
                  " onmouseover="this.style.backgroundColor='#1e293b'" onmouseout="this.style.backgroundColor='#0f172a'">
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>
                  Navegar até o carro
                  </a>
              </div>
            `;
            marker.bindPopup(popupContent);
            markersLayer.addLayer(marker);
        });
      }

      // 2. Add POIs (Static + Approved from DB)
      allPointsOfInterest.forEach(loc => {
        // FILTER LOGIC
        if (activePoiFilter !== 'ALL') {
            if (activePoiFilter !== loc.type) {
                return;
            }
        }

        let bgColor = '#64748b'; 
        let svgIcon = '';

        // Updated Icon/Color Logic
        switch (loc.type) {
            case 'FUEL':
                bgColor = '#9333ea'; // Purple
                svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="3" x2="15" y1="22" y2="22"/><line x1="4" x2="14" y1="9" y2="9"/><path d="M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18"/><path d="M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5"/></svg>`;
                break;
            case 'GARAGE':
                bgColor = '#16a34a'; // Green
                svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M22 8.35V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V8.35A2 2 0 0 1 3.26 6.5l8-3.2a2 2 0 0 1 1.48 0l8 3.2A2 2 0 0 1 22 8.35Z"/><path d="M6 18h12"/><path d="M6 14h12"/></svg>`;
                break;
            case 'BATHROOM':
                bgColor = '#ec4899'; // Pink
                svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6 6.5 3.5a1.5 1.5 0 0 0-1-.5C4.683 3 4 3.683 4 4.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"/><line x1="10" x2="8" y1="5" y2="7"/><line x1="2" x2="22" y1="12" y2="12"/><line x1="7" x2="7" y1="19" y2="21"/><line x1="17" x2="17" y1="19" y2="21"/></svg>`;
                break;
            case 'FOOD':
                bgColor = '#f97316'; // Orange
                svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/></svg>`;
                break;
            case 'NO_ZONA_AZUL':
                bgColor = '#3b82f6'; // Blue
                svgIcon = `<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M9 17V7h4a3 3 0 0 1 0 6H9"/></svg>`;
                break;
        }

        // Add visual indicator for Pending status
        const opacity = (loc as any).isPending ? '0.7' : '1';
        const borderStyle = (loc as any).isPending ? 'dashed' : 'solid';

        const iconHtml = `
          <div style="
            background-color: ${bgColor};
            width: 34px;
            height: 34px;
            border-radius: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px ${borderStyle} white;
            box-shadow: 0 4px 6px rgba(0,0,0,0.3);
            opacity: ${opacity};
          ">
            ${svgIcon}
          </div>
        `;

        const customIcon = L.divIcon({
          html: iconHtml,
          className: 'custom-fixed-marker',
          iconSize: [34, 34],
          iconAnchor: [17, 17],
          popupAnchor: [0, -17]
        });

        const marker = L.marker([loc.lat, loc.lon], { icon: customIcon });
        const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${loc.lat},${loc.lon}`;

        // Specific message for Bathroom safety
        let safetyBadge = '';
        if (loc.type === 'BATHROOM') {
            safetyBadge = `
                <div style="margin-top:4px; margin-bottom: 4px; display:flex; gap:4px;">
                    <span style="font-size:10px; background:#fce7f3; color:#db2777; padding:2px 6px; rounded:4px; font-weight:bold; border-radius:4px;">Limpo</span>
                    <span style="font-size:10px; background:#fce7f3; color:#db2777; padding:2px 6px; rounded:4px; font-weight:bold; border-radius:4px;">Seguro</span>
                </div>
            `;
        }
        
        const pendingBadge = (loc as any).isPending 
            ? `<div style="background-color: #fff7ed; border: 1px solid #fdba74; color: #c2410c; font-size: 10px; padding: 4px; border-radius: 4px; margin-bottom: 6px;">⏳ Sugestão enviada (Aguardando Moderação)</div>` 
            : '';

        const popupContent = `
          <div style="font-family: 'Inter', sans-serif; color: #0f172a; min-width: 220px;">
             ${pendingBadge}
             <div style="border-bottom: 2px solid ${bgColor}; padding-bottom: 6px; margin-bottom: 8px;">
                <strong style="font-size: 15px; display:flex; align-items:center; gap:4px; color: ${bgColor};">
                  ${loc.name}
                  ${isFresh((loc as any).created_at) ? '<span style="background-color: #10b981; color: white; padding: 2px 4px; border-radius: 4px; font-size: 10px; font-weight: bold; line-height: 1;">NOVO</span>' : ''}
                </strong>
             </div>
             ${safetyBadge}
             <p style="font-size: 12px; margin-bottom: 6px; color: #334155; font-weight: 500;">${loc.address}</p>
             <div style="background-color: #f1f5f9; padding: 6px; border-radius: 4px; border-left: 3px solid ${bgColor};">
                 <p style="font-size: 11px; color: #475569; line-height: 1.4;">${loc.message}</p>
             </div>
             <a href="${mapsUrl}" target="_blank" rel="noopener noreferrer" style="
                display: flex;
                align-items: center;
                justify-content: center;
                gap: 6px;
                background-color: ${bgColor};
                color: white;
                text-decoration: none;
                padding: 8px 12px;
                border-radius: 6px;
                font-size: 12px;
                font-weight: 600;
                margin-top: 10px;
                text-align: center;
                transition: opacity 0.2s;
            " onmouseover="this.style.opacity='0.9'" onmouseout="this.style.opacity='1'">
               <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="3 11 22 2 13 21 11 13 3 11"/></svg>
               Navegar
            </a>
          </div>
        `;

        marker.bindPopup(popupContent);
        markersLayer.addLayer(marker);
      });
    }
  }, [activeTab, showVehicles, filteredFleet, favorites, activePoiFilter, allPointsOfInterest, isPickingLocation]); 

  const flyToLocation = (lat: number, lon: number, openPopup: boolean = true) => {
    setActiveTab('MAP');
    // If we can't find map ref immediately, set a pending state
    if (!mapRef.current) {
        setPendingFlyTo({ lat, lon });
    } else {
        setTimeout(() => {
            mapRef.current?.flyTo([lat, lon], 16, { duration: 1.5 });
        }, 100);
    }
  };

  const handleZoomIn = () => { if (mapRef.current) mapRef.current.zoomIn(); };
  const handleZoomOut = () => { if (mapRef.current) mapRef.current.zoomOut(); };
  
  const handleFitBounds = () => {
      if (!mapRef.current || filteredFleet.length === 0) return;
      const bounds = L.latLngBounds(filteredFleet.map(c => [c.lat, c.lon]));
      allPointsOfInterest.forEach(l => bounds.extend([l.lat, l.lon]));
      mapRef.current.fitBounds(bounds, { padding: [50, 50] });
  };

  const handleLocateUser = () => {
    if (!navigator.geolocation) {
        setGeoError("Geolocalização não é suportada.");
        setTimeout(() => setGeoError(null), 5000);
        return;
    }
    setIsLocating(true);
    setGeoError(null);
    navigator.geolocation.getCurrentPosition(
        (position) => {
            const { latitude, longitude } = position.coords;
            setIsLocating(false);
            if (mapRef.current) {
                mapRef.current.flyTo([latitude, longitude], 15, { duration: 1.5 });
                if (userLocationMarkerRef.current) {
                    userLocationMarkerRef.current.setLatLng([latitude, longitude]);
                } else {
                    const userIcon = L.divIcon({
                        html: `
                          <div style="background-color: #38bdf8; width: 20px; height: 20px; border-radius: 50%; border: 3px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3); animation: softPulse 3s infinite ease-out;"></div>
                          <style>@keyframes softPulse { 0% { transform: scale(1); box-shadow: 0 0 0 0 rgba(56, 189, 248, 0.7); } 50% { transform: scale(1.05); box-shadow: 0 0 0 12px rgba(56, 189, 248, 0); } 100% { transform: scale(1); box-shadow: 0 0 0 0 rgba(56, 189, 248, 0); } }</style>
                        `,
                        className: 'user-location-marker',
                        iconSize: [20, 20],
                        iconAnchor: [10, 10]
                    });
                    userLocationMarkerRef.current = L.marker([latitude, longitude], { icon: userIcon }).addTo(mapRef.current).bindPopup("Você está aqui");
                }
                userLocationMarkerRef.current.openPopup();
            }
        },
        (error) => {
            setIsLocating(false);
            let errorMessage = "Não foi possível obter sua localização.";
            if (error.code === error.PERMISSION_DENIED) errorMessage = "Permissão de localização negada.";
            setGeoError(errorMessage);
            setTimeout(() => setGeoError(null), 5000);
        },
        { enableHighAccuracy: true }
    );
  };

  // ── GPS: Mapear Localização Instantânea para o formulário de sugestão
  const handleGpsMap = () => {
    if (!navigator.geolocation) {
      alert('Geolocalização não suportada neste dispositivo.');
      return;
    }
    setIsGpsMapping(true);
    setGpsDetectedAddress(null);
    navigator.geolocation.getCurrentPosition(
      async (position) => {
        const { latitude, longitude } = position.coords;
        setGpsCoords({ lat: latitude, lon: longitude });
        try {
          const res = await fetch(
            `https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}`,
            { headers: { 'User-Agent': 'DriverScoreApp' } }
          );
          const data = await res.json();
          const raw = data?.display_name || '';
          const simplified = simplifyAddress(raw);
          setGpsDetectedAddress(simplified || raw);
        } catch {
          setGpsDetectedAddress(`${latitude.toFixed(5)}, ${longitude.toFixed(5)}`);
        }
        setIsGpsMapping(false);
        setShowGpsConfirm(true);
      },
      (err) => {
        setIsGpsMapping(false);
        let msg = 'Não foi possível obter a localização.';
        if (err.code === err.PERMISSION_DENIED) msg = 'Permissão de GPS negada. Libere nas configurações.';
        alert(msg);
      },
      { enableHighAccuracy: true, timeout: 10000 }
    );
  };

  const confirmGpsLocation = () => {
    if (!gpsCoords || !gpsDetectedAddress) return;
    setSuggestForm(prev => ({
      ...prev,
      lat: gpsCoords.lat,
      lon: gpsCoords.lon,
      endereco: gpsDetectedAddress
    }));
    setShowGpsConfirm(false);
    setGpsDetectedAddress(null);
    setGpsCoords(null);
  };

  const handleSuggestSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (suggestForm.type === 'VEHICLE' && (!suggestForm.placa || !suggestForm.modelo)) return;
    if (suggestForm.type !== 'VEHICLE' && !suggestForm.modelo) return;
    
    // VALIDATE COORDINATES: Strict check for 0,0 to prevent "Praça da Sé" error
    if (suggestForm.lat === 0 || suggestForm.lon === 0) {
        alert("Por favor, selecione o ponto exato no mapa primeiro.");
        return;
    }

    setIsConfirming(true);
  };

  const finalizeSuggestion = async () => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) { alert("Sessão expirada."); setIsConfirming(false); return; }
    
    // SAFETY CHECK: Ensure lat/lon are set
    if (!suggestForm.lat || !suggestForm.lon || suggestForm.lat === 0) {
        alert("Erro crítico: Coordenadas inválidas. Por favor, selecione o local no mapa novamente.");
        setIsConfirming(false);
        return;
    }

    setIsSending(true); // Start loading

    // Prepare Data
    const isVehicle = suggestForm.type === 'VEHICLE';
    const finalPlaca = isVehicle ? suggestForm.placa?.toUpperCase() : 'POI';
    
    // Prefix Model with Type for POIs to help admin identify
    let finalModelo = suggestForm.modelo;
    if (!isVehicle) {
        // e.g. "RESTAURANTE: Prato Feito"
        finalModelo = `${suggestForm.type}: ${suggestForm.modelo}`;
    }

    const newReq = { 
        placa: finalPlaca, 
        modelo: finalModelo, 
        endereco: suggestForm.endereco || 'Endereço não informado', 
        lat: suggestForm.lat, 
        lon: suggestForm.lon, 
        status: 'pending', 
        user_email: userEmail 
    };

    try {
        const { error } = await supabase.from('fleet_requests').insert([newReq]);
        if (error) throw error;
        
        // Optimistic update
        setPendingRequests([...pendingRequests, { ...newReq, status: 'pending' } as CarRequest]);
        
        // Reset form
        setSuggestForm({ 
            type: 'VEHICLE', 
            placa: '', 
            modelo: '', 
            endereco: '', 
            lat: 0, 
            lon: 0,
            description: ''
        });
        
        setSuccessMessage("Solicitação enviada para aprovação!");
        setTimeout(() => setSuccessMessage(null), 4000);
        setIsConfirming(false); // Close modal only on success

    } catch (err) { 
        alert("Erro ao enviar sugestão."); 
        setIsConfirming(false);
    } finally { 
        setIsSending(false); 
    }
  };

  const handleApprove = async (req: CarRequest) => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) { alert("Sessão expirada."); return; }

    // Guard: lat/lon must be valid numbers
    const lat = parseFloat(String(req.lat));
    const lon = parseFloat(String(req.lon));
    if (isNaN(lat) || isNaN(lon) || lat === 0 || lon === 0) {
        alert("Erro: coordenadas inválidas. Edite a solicitação e corrija o endereço antes de aprovar.");
        return;
    }

    try {
        let finalPlaca = req.placa;
        if (req.placa === 'POI') {
            finalPlaca = `POI-${Date.now()}`;
        } else {
            // ── Verificar duplicata ANTES de inserir ──
            const { data: existing } = await supabase
                .from('fleet_cars')
                .select('placa')
                .eq('placa', finalPlaca)
                .maybeSingle();

            if (existing) {
                const reject = window.confirm(
                    `⚠️ A placa "${finalPlaca}" já existe na frota!\n\nDeseja REJEITAR esta solicitação duplicada?`
                );
                if (reject) {
                    if (req.id) await supabase.from('fleet_requests').delete().eq('id', req.id);
                    setPendingRequests(pendingRequests.filter(p => p.id !== req.id));
                }
                return;
            }
        }

        const { error: insertError } = await supabase.from('fleet_cars').insert([{
            placa: finalPlaca,
            modelo: req.modelo,
            endereco: req.endereco,
            lat: lat,
            lon: lon
        }]);

        if (insertError) throw insertError;

        // Gamification reward
        if (req.user_email) {
            await rewardUserByEmail(req.user_email, XP_VALUES.LOCATION_APPROVED);
        }

        // Delete from requests after approving
        if (req.id) {
            const { error: deleteError } = await supabase.from('fleet_requests').delete().eq('id', req.id);
            if (deleteError) {
                console.error('Failed to delete approved request, marking as approved:', deleteError);
                // Fallback: mark as approved so it won't show again
                await supabase.from('fleet_requests').update({ status: 'approved' }).eq('id', req.id);
            }
        }

        // Update local state
        setFleet([...fleet, { ...req, placa: finalPlaca, lat, lon }]);
        setPendingRequests(pendingRequests.filter(p => p.id !== req.id));

    } catch (err: any) {
        console.error("Erro ao aprovar solicitação:", err);
        alert(`Erro ao aprovar: ${err?.message || err?.code || JSON.stringify(err)}`);
    }
  };

  const handleReject = async (req: CarRequest) => {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) { alert("Sessão expirada."); return; }
    try {
        if (req.id) {
            const { error: deleteError } = await supabase.from('fleet_requests').delete().eq('id', req.id);
            if (deleteError) {
                console.error('Failed to delete rejected request, marking as rejected:', deleteError);
                await supabase.from('fleet_requests').update({ status: 'rejected' }).eq('id', req.id);
            }
        }
        setPendingRequests(pendingRequests.filter(p => p.id !== req.id));
    } catch (err) { alert("Erro ao rejeitar."); }
  };

  const handleDeleteCar = async (car: Car) => { setCarToDelete(car); };

  const finalizeCarDeletion = async () => {
      if (!carToDelete) return;
      const { data: { user } } = await supabase.auth.getUser();
      if (!user) { alert("Sessão expirada."); return; }
      try {
          const { error } = await supabase.from('fleet_cars').delete().eq('placa', carToDelete.placa);
          if (error) throw error;
          setFleet(fleet.filter(c => c.placa !== carToDelete.placa));
          if (favorites.includes(carToDelete.placa)) setFavorites(favorites.filter(p => p !== carToDelete.placa));
      } catch (err) { alert("Erro ao excluir veículo."); } finally { setCarToDelete(null); }
  };

  const handleEditCar = (car: Car) => { setCarToEdit(car); setEditAddress(car.endereco); };
  
  // New handler for editing pending requests in Admin view
  const handleEditRequest = (req: CarRequest) => { setRequestToEdit(req); setEditAddress(req.endereco); };

  const saveLocationUpdate = async () => {
    // Determine if we are editing a live car OR a pending request
    const isPending = !!requestToEdit;
    const target = isPending ? requestToEdit : carToEdit;
    
    if (!target || !editAddress.trim()) return;
    
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) { alert("Sessão expirada."); return; }
    setIsUpdatingLocation(true);
    
    try {
        let query = editAddress;
        if (!query.toLowerCase().includes('são paulo') && !query.toLowerCase().includes('sp')) query = `${query}, São Paulo`;
        const response = await fetch(`https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(query)}&limit=1`, { headers: { 'User-Agent': 'DriverScoreApp' } });
        const data = await response.json();
        if (!data || data.length === 0) throw new Error("Endereço não encontrado.");
        const lat = parseFloat(data[0].lat);
        const lon = parseFloat(data[0].lon);
        
        if (isPending) {
            // Update Pending Request
            const { error } = await supabase.from('fleet_requests').update({ endereco: editAddress, lat: lat, lon: lon }).eq('id', requestToEdit?.id);
            if (error) throw error;
            // Update Local State
            setPendingRequests(pendingRequests.map(r => r.id === requestToEdit?.id ? { ...r, endereco: editAddress, lat, lon } : r));
            setRequestToEdit(null);
        } else {
            // Update Live Car
            const { error } = await supabase.from('fleet_cars').update({ endereco: editAddress, lat: lat, lon: lon }).eq('placa', carToEdit?.placa);
            if (error) throw error;
            setFleet(fleet.map(c => c.placa === carToEdit?.placa ? { ...c, endereco: editAddress, lat, lon } : c));
            setCarToEdit(null);
        }

        setSuccessMessage("Localização atualizada com sucesso!");
        setTimeout(() => setSuccessMessage(null), 3000);
        
    } catch (err: any) { alert(err.message || "Erro ao atualizar localização."); } finally { setIsUpdatingLocation(false); }
  };

  const handleAiSearch = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!aiQuery.trim()) return;
    setAiLoading(true); setAiError(null); setAiResult(null);
    try {
        // Try to get user location if available for better relevance
        let userLocation = undefined;
        if (navigator.geolocation) {
            try {
                const pos = await new Promise<GeolocationPosition>((resolve, reject) => {
                    navigator.geolocation.getCurrentPosition(resolve, reject, { timeout: 3000 });
                });
                userLocation = { lat: pos.coords.latitude, lon: pos.coords.longitude };
            } catch (e) {
                // Ignore location error, proceed without it
            }
        }

        const response = await searchPlacesWithMaps(aiQuery, userLocation);
        const candidate = response.candidates?.[0];
        const text = candidate?.content?.parts?.map((p: any) => p.text).join('') || "Sem resposta.";
        const grounding = candidate?.groundingMetadata?.groundingChunks || [];
        setAiResult({ text, grounding });
    } catch (err: any) {
        if (err.message === 'QUOTA_EXCEEDED') setAiError("Cota da API excedida.");
        else if (err.message === 'API_KEY_MISSING') setAiError("Chave de API necessária.");
        else setAiError("Erro ao buscar informações.");
    } finally { setAiLoading(false); }
  };

  const handleAddToMapFromAI = () => {
    // Prefer title from the first grounding chunk if available, otherwise use query
    const addressToSave = aiResult?.grounding?.[0]?.web?.title || aiQuery;
    
    // Switch to suggestion tab and pre-fill
    setSuggestForm({ 
        ...suggestForm, 
        type: 'FOOD', // Defaulting to FOOD, user can change
        endereco: addressToSave, 
        placa: 'POI', 
        modelo: 'Base Sugerida' 
    });
    setActiveTab('SUGGEST');
    setSuccessMessage("Confirme os dados e o local no mapa para enviar.");
    setTimeout(() => setSuccessMessage(null), 4000);
  };

  const favoriteCars = fleet.filter(c => favorites.includes(c.placa));

  return (
    <div className="space-y-6 animate-fade-in pb-20 relative">
      {dbError && isAdmin && (
         <div className="bg-red-900/30 border border-red-800 p-4 rounded-xl flex items-start gap-4 mb-4">
             <Database className="w-6 h-6 text-red-400 mt-1" />
             <div>
                 <h3 className="text-red-300 font-bold">Banco de Dados não Configurado</h3>
                 <p className="text-red-200/70 text-sm mt-2">Copie o código SQL fornecido.</p>
             </div>
         </div>
      )}

      <div className="flex flex-col md:flex-row justify-between items-center gap-4">
        <h2 className="text-2xl font-bold text-white flex items-center gap-2">
          <MapPin className="w-6 h-6 text-orange-500" />
          Localizar Bases
        </h2>
        <div className="flex bg-slate-800 p-1 rounded-lg flex-wrap justify-center">
          <button onClick={() => { setIsPickingLocation(false); setActiveTab('MAP'); }} className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${activeTab === 'MAP' ? 'bg-slate-600 text-white' : 'text-slate-400 hover:text-white'}`}>Mapa</button>
          <button onClick={() => { setIsPickingLocation(false); setActiveTab('SUGGEST'); }} className={`px-3 py-2 rounded-md text-sm font-medium transition-colors ${activeTab === 'SUGGEST' ? 'bg-slate-600 text-white' : 'text-slate-400 hover:text-white'}`}>Sugerir</button>
          <button onClick={() => setActiveTab('AI_SEARCH')} className={`px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-1 ${activeTab === 'AI_SEARCH' ? 'bg-blue-900/40 text-blue-200' : 'text-slate-400 hover:text-white'}`}><Sparkles className="w-3 h-3" /> IA</button>
          {isAdmin && (
            <button onClick={() => setActiveTab('ADMIN')} className={`px-3 py-2 rounded-md text-sm font-medium transition-colors flex items-center gap-1 ${activeTab === 'ADMIN' ? 'bg-orange-900/50 text-orange-200' : 'text-slate-400 hover:text-white'}`}>
                <ShieldAlert className="w-3 h-3" /> Admin 
                {pendingRequests.length > 0 && <span className="ml-1 bg-red-500 text-white text-[10px] px-1.5 rounded-full">{pendingRequests.length}</span>}
            </button>
          )}
        </div>
      </div>

      {(activeTab === 'MAP' || (activeTab === 'SUGGEST' && isPickingLocation)) && (
        <div className="flex flex-col gap-6">
          {!isPickingLocation && (
            <div className="flex gap-2 mb-[-10px] z-10 relative overflow-x-auto pb-2 px-1 -mx-1 scrollbar-hide">
               <button type="button" onClick={() => setShowVehicles(!showVehicles)} className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-bold border flex items-center gap-2 transition-colors ${showVehicles ? 'bg-slate-950 text-white border-slate-700 shadow-md' : 'bg-slate-800 text-slate-500 border-slate-700 hover:bg-slate-700'}`}>
                  {showVehicles ? <Eye className="w-3 h-3" /> : <EyeOff className="w-3 h-3" />} Veículos
               </button>
               
               <div className="h-6 w-[1px] bg-slate-700 mx-1 self-center shrink-0"></div>
               
               <button type="button" onClick={() => setActivePoiFilter(activePoiFilter === 'BATHROOM' ? 'ALL' : 'BATHROOM')} className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-bold border flex items-center gap-2 transition-colors ${activePoiFilter === 'BATHROOM' ? 'bg-pink-600 text-white border-pink-500 shadow-md' : 'bg-slate-800 text-slate-400 border-slate-700 hover:bg-slate-700 hover:text-pink-300'}`}>
                  <Bath className="w-3 h-3" /> Banheiros
               </button>
               
               <button type="button" onClick={() => setActivePoiFilter(activePoiFilter === 'FOOD' ? 'ALL' : 'FOOD')} className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-bold border flex items-center gap-2 transition-colors ${activePoiFilter === 'FOOD' ? 'bg-orange-600 text-white border-orange-500 shadow-md' : 'bg-slate-800 text-slate-400 border-slate-700 hover:bg-slate-700 hover:text-orange-300'}`}>
                  <Utensils className="w-3 h-3" /> Restaurantes
               </button>
               
               <button type="button" onClick={() => setActivePoiFilter(activePoiFilter === 'NO_ZONA_AZUL' ? 'ALL' : 'NO_ZONA_AZUL')} className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-bold border flex items-center gap-2 transition-colors ${activePoiFilter === 'NO_ZONA_AZUL' ? 'bg-blue-600 text-white border-blue-500 shadow-md' : 'bg-slate-800 text-slate-400 border-slate-700 hover:bg-slate-700 hover:text-blue-300'}`}>
                  <ParkingSquare className="w-3 h-3" /> Sem Zona Azul
               </button>
               
               <button type="button" onClick={() => setActivePoiFilter(activePoiFilter === 'FUEL' ? 'ALL' : 'FUEL')} className={`shrink-0 px-3 py-1.5 rounded-full text-xs font-bold border flex items-center gap-2 transition-colors ${activePoiFilter === 'FUEL' ? 'bg-purple-600 text-white border-purple-500 shadow-md' : 'bg-slate-800 text-slate-400 border-slate-700 hover:bg-slate-700 hover:text-purple-300'}`}>
                  <Fuel className="w-3 h-3" /> Postos
               </button>
            </div>
          )}

          <div className="w-full h-[400px] bg-slate-800/60 backdrop-blur-md rounded-2xl border border-slate-700/50 overflow-hidden relative shadow-2xl z-0">
             <div ref={mapContainerRef} className="w-full h-full" id="map-container"></div>
             
             {isPickingLocation && (
                 <div className="absolute top-4 left-1/2 transform -translate-x-1/2 z-[1000] bg-orange-600 text-white px-4 py-2 rounded-full shadow-lg font-bold text-sm animate-pulse whitespace-nowrap border-2 border-white/20">
                    📍 Toque no local exato no mapa
                 </div>
             )}

             <div className="absolute top-4 right-4 z-[1000] flex flex-col gap-3">
                 <div className="bg-slate-900/90 backdrop-blur border border-slate-700 rounded-lg shadow-xl flex flex-col overflow-hidden">
                     <button type="button" onClick={handleZoomIn} className="p-2 hover:bg-slate-800 text-slate-200 hover:text-white transition-colors"><Plus className="w-5 h-5" /></button>
                     <div className="h-[1px] bg-slate-700 w-full" />
                     <button type="button" onClick={handleZoomOut} className="p-2 hover:bg-slate-800 text-slate-200 hover:text-white transition-colors"><Minus className="w-5 h-5" /></button>
                 </div>
                 <button type="button" onClick={handleFitBounds} className="bg-slate-900/90 backdrop-blur border border-slate-700 rounded-lg shadow-xl p-2 hover:bg-slate-800 text-slate-200 hover:text-white transition-colors"><Maximize className="w-5 h-5" /></button>
                 <button type="button" onClick={handleLocateUser} disabled={isLocating} className="bg-slate-900/90 backdrop-blur border border-slate-700 rounded-lg shadow-xl p-2 hover:bg-slate-800 text-blue-400 hover:text-blue-300 transition-colors disabled:opacity-50">{isLocating ? <Loader2 className="w-5 h-5 animate-spin" /> : <LocateFixed className="w-5 h-5" />}</button>
             </div>
             {geoError && <div className="absolute top-4 left-1/2 transform -translate-x-1/2 p-3 bg-red-900/90 text-xs text-red-100 rounded-lg border border-red-700 shadow-xl animate-fade-in text-center z-[1000] backdrop-blur-sm flex items-center gap-2"><ShieldAlert className="w-4 h-4" />{geoError}</div>}
             
             {isPickingLocation && (
                 <div className="absolute bottom-6 left-1/2 transform -translate-x-1/2 z-[1000]">
                    <button onClick={() => setIsPickingLocation(false)} className="bg-slate-800/90 backdrop-blur text-white px-6 py-2 rounded-full shadow-lg border border-slate-600 font-medium hover:bg-slate-700 transition-colors">
                        Cancelar Seleção
                    </button>
                 </div>
             )}
          </div>

          {!isPickingLocation && (
            <>
              <div className={`transition-all duration-300 ${loadingFavorites ? 'opacity-70' : 'opacity-100'}`}>
                {loadingFavorites ? (
                     <div className="bg-slate-800/30 border border-slate-700 rounded-xl p-4 flex items-center justify-center gap-2 text-slate-400 h-24"><Loader2 className="w-5 h-5 animate-spin" /><span>Carregando favoritos...</span></div>
                ) : favoriteCars.length > 0 && (
                    <div className="bg-slate-800/50 border border-yellow-500/30 rounded-xl p-4 shadow-lg shadow-yellow-900/10">
                    <h3 className="text-sm font-bold text-yellow-500 mb-3 flex items-center gap-2"><Star className="w-4 h-4 fill-yellow-500" /> Meus Favoritos</h3>
                    <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                        {favoriteCars.map(car => (
                        <div key={car.placa} onClick={() => flyToLocation(car.lat, car.lon)} className="bg-slate-900 p-3 rounded-lg border border-yellow-900/30 flex justify-between items-center cursor-pointer hover:border-yellow-500/50 transition-colors">
                            <div><p className="font-bold text-white font-mono text-lg">{car.placa}</p><p className="text-xs text-slate-400">{car.modelo}</p></div>
                            <div className="flex items-center gap-1"><button onClick={(e) => { e.stopPropagation(); toggleFavorite(car.placa); }} className="p-2 rounded-full hover:bg-red-900/30 transition-colors group"><Trash2 className="w-4 h-4 text-slate-500 group-hover:text-red-400" /></button></div>
                        </div>
                        ))}
                    </div>
                    </div>
                )}
              </div>

              <div className="bg-slate-800/60 backdrop-blur-md rounded-2xl border border-slate-700/50 p-6 shadow-xl">
                 <button
                    type="button"
                    onClick={() => setIsVehicleListOpen(!isVehicleListOpen)}
                    className="w-full flex items-center justify-between text-white font-bold"
                 >
                    <span className="flex items-center gap-2">
                        <CarIcon className="w-5 h-5 text-orange-400" /> Lista de Veículos e Locais
                    </span>
                    {isVehicleListOpen ? <ChevronUp className="w-5 h-5 text-slate-400" /> : <ChevronDown className="w-5 h-5 text-slate-400" />}
                 </button>

                 {isVehicleListOpen && (
                    <div className="mt-6 flex flex-col gap-4 animate-fade-in">
                        <div className="relative">
                          <Search className="absolute left-3 top-3.5 w-5 h-5 text-slate-500" />
                          <input type="text" placeholder="Buscar por placa, modelo ou endereço..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} className="w-full bg-slate-900 border border-slate-600 rounded-lg pl-10 pr-4 py-3 text-white focus:ring-2 focus:ring-orange-500 outline-none" />
                           {searchInput && <button type="button" onClick={() => { setSearchInput(''); setSearchTerm(''); }} className="absolute right-3 top-3.5 text-slate-500 hover:text-white"><XCircle className="w-5 h-5" /></button>}
                        </div>
                        <div className="space-y-3">
                          {filteredFleet.length === 0 ? <p className="text-center text-slate-500 py-4">Nenhum veículo encontrado.</p> : filteredFleet.map((car) => {
                              const isFav = favorites.includes(car.placa);
                              return (
                                <div key={car.placa} className="bg-slate-900/50 p-4 rounded-lg border border-slate-700 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4 hover:border-slate-500 transition-colors">
                                  <div className="flex gap-4 items-center min-w-0">
                                    <div className="bg-slate-800 p-3 rounded-full shrink-0">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-slate-400"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M2 12h12"/></svg>
                                    </div>
                                    <div className="min-w-0">
                                      <div className="flex flex-col">
                                        <div className="flex items-center gap-2">
                                          <h4 className="font-bold text-white text-xl font-mono tracking-wider">{car.placa}</h4>
                                          {isFresh(car.created_at) && <span className="bg-emerald-500 text-white font-bold text-[10px] px-1.5 py-0.5 rounded leading-none">NOVO</span>}
                                        </div>
                                        <p className="text-sm text-slate-400">{car.modelo}</p>
                                      </div>
                                      <p className="text-xs text-slate-500 mt-1 truncate max-w-[200px] sm:max-w-xs" title={car.endereco}>
                                        {simplifyAddress(car.endereco)}
                                      </p>
                                    </div>
                                  </div>
                                  <div className="flex items-center gap-2 w-full sm:w-auto">
                                    <button type="button" onClick={(e) => { e.stopPropagation(); toggleFavorite(car.placa); }} className={`p-2 rounded-lg transition-colors flex-1 sm:flex-none flex justify-center ${isFav ? 'bg-yellow-900/30 text-yellow-500' : 'bg-slate-800 text-slate-400 hover:text-white'}`}><Star className={`w-5 h-5 ${isFav ? 'fill-yellow-500' : ''}`} /></button>
                                    <button type="button" onClick={() => flyToLocation(car.lat, car.lon)} className="bg-blue-600 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded-lg flex items-center justify-center gap-2 transition-colors flex-1 sm:flex-none"><Navigation className="w-4 h-4" /><span className="hidden sm:inline">Ver no Mapa</span><span className="sm:hidden">Mapa</span></button>
                                    {isAdmin && (
                                        <><button type="button" onClick={() => handleEditCar(car)} className="bg-slate-800 hover:bg-blue-900/50 text-slate-400 hover:text-blue-400 font-bold py-2 px-3 rounded-lg transition-colors"><Edit className="w-4 h-4" /></button><button onClick={() => handleDeleteCar(car)} className="bg-slate-800 hover:bg-red-900/50 text-slate-400 hover:text-red-400 font-bold py-2 px-3 rounded-lg transition-colors"><Trash2 className="w-4 h-4" /></button></>
                                    )}
                                  </div>
                                </div>
                              );
                            })
                          }
                        </div>
                    </div>
                 )}
              </div>
            </>
          )}
        </div>
      )}

      {activeTab === 'AI_SEARCH' && (
        <div className="bg-slate-800/60 backdrop-blur-md rounded-2xl border border-slate-700/50 p-6 min-h-[400px] shadow-xl">
           <h3 className="text-lg font-bold text-white mb-2 flex items-center gap-2"><Sparkles className="w-5 h-5 text-blue-400" /> Busca Inteligente</h3>
           <p className="text-slate-400 text-sm mb-6">Use a inteligência artificial do Google Maps para encontrar restaurantes, postos ou locais úteis.</p>
           
           <form onSubmit={handleAiSearch} className="mb-8">
              <div className="flex gap-2">
                 <input 
                    type="text" 
                    value={aiQuery} 
                    onChange={(e) => setAiQuery(e.target.value)} 
                    placeholder="Ex: Restaurantes baratos perto de mim..." 
                    className="flex-grow bg-slate-900 border border-slate-600 rounded-lg p-3 text-white focus:ring-2 focus:ring-blue-500 outline-none" 
                 />
                 <button 
                    type="submit" 
                    disabled={aiLoading || !aiQuery.trim()} 
                    className="bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-bold px-6 py-3 rounded-lg transition-colors flex items-center gap-2"
                 >
                    {aiLoading ? <Loader2 className="w-5 h-5 animate-spin" /> : <Search className="w-5 h-5" />}
                    <span className="hidden sm:inline">Pesquisar</span>
                 </button>
              </div>
           </form>

           {aiError && (
               <div className="bg-red-900/20 border border-red-800 text-red-300 p-4 rounded-lg mb-6 flex items-center gap-3">
                   <ShieldAlert className="w-5 h-5" />{aiError}
               </div>
           )}

           {aiResult && (
              <div className="animate-fade-in space-y-6">
                 {/* Text Response */}
                 <div className="bg-slate-900/50 border border-slate-700 rounded-xl p-5">
                     <p className="text-slate-200 leading-relaxed whitespace-pre-wrap">{aiResult.text}</p>
                 </div>

                 {/* Action Button: Add to Map */}
                 <div className="flex justify-end">
                     <button 
                        type="button" 
                        onClick={handleAddToMapFromAI} 
                        className="bg-green-600 hover:bg-green-700 text-white font-bold px-4 py-3 rounded-lg flex items-center gap-2 transition-colors text-sm shadow-lg border border-green-500/50 hover:shadow-green-500/20"
                     >
                        <MapPlus className="w-5 h-5" /> 
                        Salvar Local no Mapa (Sugerir)
                     </button>
                 </div>

                 {/* Grounding Chips (Google Maps Links) */}
                 {aiResult.grounding && aiResult.grounding.length > 0 && (
                    <div className="border-t border-slate-700/50 pt-4">
                        <h4 className="text-xs font-bold text-slate-500 uppercase mb-3 tracking-wider flex items-center gap-2">
                            <Globe className="w-3 h-3" /> Fontes e Mapas
                        </h4>
                        <div className="flex flex-wrap gap-2">
                            {aiResult.grounding.map((chunk: any, i: number) => { 
                                let uri = chunk.web?.uri || chunk.maps?.uri; 
                                let title = chunk.web?.title || chunk.maps?.title || "Ver no Google Maps"; 
                                if (!uri) return null; 
                                return ( 
                                    <a key={i} href={uri} target="_blank" rel="noopener noreferrer" className="bg-slate-700 hover:bg-slate-600 text-blue-300 hover:text-white px-3 py-1.5 rounded-full text-xs font-medium border border-slate-600 flex items-center gap-2 transition-colors">
                                        <MapPin className="w-3 h-3" /> {title} <ExternalLink className="w-3 h-3 opacity-50" />
                                    </a> 
                                ); 
                            })}
                        </div>
                    </div>
                 )}
              </div>
           )}
        </div>
      )}

      {activeTab === 'SUGGEST' && !isPickingLocation && (
        <div className="bg-slate-800/60 backdrop-blur-md rounded-2xl border border-slate-700/50 p-6 relative shadow-xl">
          <h3 className="text-lg font-bold text-white mb-4">Adicionar ao Mapa</h3>
          <p className="text-slate-400 text-sm mb-6">Ajude a comunidade adicionando locais úteis ou reportando carros.</p>
          <form onSubmit={handleSuggestSubmit} className="space-y-4">
            
            {/* Type Selector */}
            <div>
                <label className="block text-sm font-medium text-slate-400 mb-2">Tipo de Local</label>
                <div className="grid grid-cols-2 sm:grid-cols-3 gap-2">
                    <button type="button" onClick={() => setSuggestForm({...suggestForm, type: 'VEHICLE'})} className={`p-3 rounded-lg border text-sm flex flex-col items-center gap-1 transition-colors ${suggestForm.type === 'VEHICLE' ? 'bg-slate-700 border-white text-white' : 'bg-slate-900 border-slate-700 text-slate-500'}`}>
                        <CarIcon className="w-5 h-5" /> Veículo
                    </button>
                    <button type="button" onClick={() => setSuggestForm({...suggestForm, type: 'FOOD'})} className={`p-3 rounded-lg border text-sm flex flex-col items-center gap-1 transition-colors ${suggestForm.type === 'FOOD' ? 'bg-orange-900/50 border-orange-500 text-orange-200' : 'bg-slate-900 border-slate-700 text-slate-500'}`}>
                        <Utensils className="w-5 h-5" /> Comida
                    </button>
                    <button type="button" onClick={() => setSuggestForm({...suggestForm, type: 'BATHROOM'})} className={`p-3 rounded-lg border text-sm flex flex-col items-center gap-1 transition-colors ${suggestForm.type === 'BATHROOM' ? 'bg-pink-900/50 border-pink-500 text-pink-200' : 'bg-slate-900 border-slate-700 text-slate-500'}`}>
                        <Bath className="w-5 h-5" /> Banheiro
                    </button>
                    <button type="button" onClick={() => setSuggestForm({...suggestForm, type: 'NO_ZONA_AZUL'})} className={`p-3 rounded-lg border text-sm flex flex-col items-center gap-1 transition-colors ${suggestForm.type === 'NO_ZONA_AZUL' ? 'bg-blue-900/50 border-blue-500 text-blue-200' : 'bg-slate-900 border-slate-700 text-slate-500'}`}>
                        <ParkingSquare className="w-5 h-5" /> Sem Zona Azul
                    </button>
                    <button type="button" onClick={() => setSuggestForm({...suggestForm, type: 'FUEL'})} className={`p-3 rounded-lg border text-sm flex flex-col items-center gap-1 transition-colors ${suggestForm.type === 'FUEL' ? 'bg-purple-900/50 border-purple-500 text-purple-200' : 'bg-slate-900 border-slate-700 text-slate-500'}`}>
                        <Fuel className="w-5 h-5" /> Posto
                    </button>
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {suggestForm.type === 'VEHICLE' && (
                <div>
                  <label className="block text-sm font-medium text-slate-400 mb-2">Placa</label>
                  <input
                    type="text"
                    required
                    value={suggestForm.placa}
                    onChange={(e) => setSuggestForm({ ...suggestForm, placa: formatPlate(e.target.value) })}
                    maxLength={8}
                    className="w-full bg-slate-900 border border-slate-600 rounded-lg p-3 text-white focus:ring-2 focus:ring-orange-500 outline-none font-mono tracking-widest text-lg uppercase"
                    placeholder="UDE 5J87"
                  />
                </div>
              )}
              <div className={suggestForm.type !== 'VEHICLE' ? 'col-span-2' : ''}><label className="block text-sm font-medium text-slate-400 mb-2">{suggestForm.type === 'VEHICLE' ? 'Modelo' : 'Nome do Local'}</label><input type="text" required value={suggestForm.modelo} onChange={(e) => setSuggestForm({ ...suggestForm, modelo: e.target.value })} className="w-full bg-slate-900 border border-slate-600 rounded-lg p-3 text-white focus:ring-2 focus:ring-orange-500 outline-none" placeholder={suggestForm.type === 'VEHICLE' ? 'Ex: Song Plus' : 'Ex: Restaurante do Zé'} /></div>
            </div>
            
             {/* Botão GPS + selector de mapa */}
             <div>
               <label className="block text-sm font-medium text-slate-400 mb-2">Localização Exata</label>
               <div className="flex gap-2 mb-2">
                 {/* Mapear pelo GPS */}
                 <button
                   type="button"
                   onClick={handleGpsMap}
                   disabled={isGpsMapping}
                   className="w-full bg-emerald-900/40 hover:bg-emerald-800/60 disabled:opacity-50 text-emerald-300 border border-emerald-700/60 hover:border-emerald-500 p-3 rounded-lg flex items-center justify-center gap-2 transition-all font-semibold text-sm"
                 >
                   {isGpsMapping ? (
                     <svg className="animate-spin" xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12a9 9 0 1 1-6.219-8.56"/></svg>
                   ) : (
                     <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="2" x2="5" y1="12" y2="12"/><line x1="19" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="5"/><line x1="12" x2="12" y1="19" y2="22"/><circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="3"/></svg>
                   )}
                   {isGpsMapping ? 'Localizando...' : 'Mapear Localização'}
                 </button>
               </div>
               {suggestForm.lat !== 0 && (
                  <p className="text-xs text-green-400 text-center flex items-center justify-center gap-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                    {suggestForm.endereco ? suggestForm.endereco : 'Localização capturada'}
                  </p>
                )}
             </div>

            <div><label className="block text-sm font-medium text-slate-400 mb-2">Endereço (Preenchido Automático)</label><input type="text" required value={suggestForm.endereco} onChange={(e) => setSuggestForm({ ...suggestForm, endereco: e.target.value })} className="w-full bg-slate-900 border border-slate-600 rounded-lg p-3 text-white focus:ring-2 focus:ring-orange-500 outline-none" placeholder="Rua, Número, Bairro" /></div>
            
            <button type="submit" className="w-full bg-orange-600 hover:bg-orange-700 text-white font-bold py-3 rounded-lg flex items-center justify-center gap-2 mt-4 transition-colors"><PlusCircle className="w-5 h-5" /> Enviar para o Mapa</button>
          </form>
          {successMessage && <div className="absolute top-4 left-1/2 transform -translate-x-1/2 bg-green-600 text-white px-6 py-3 rounded-full shadow-2xl flex items-center gap-2 animate-bounce z-50 whitespace-nowrap"><CheckCircle2 className="w-5 h-5" /><span>{successMessage}</span></div>}
        </div>
      )}

      {activeTab === 'ADMIN' && (
        <div className="bg-slate-800/60 backdrop-blur-md rounded-2xl border border-slate-700/50 p-6 shadow-xl">
          <h3 className="text-lg font-bold text-white mb-4 flex items-center gap-2"><ShieldAlert className="w-5 h-5 text-orange-500" /> Aprovação de Solicitações</h3>
          {!isAdmin ? (
            <div className="bg-red-900/20 border border-red-800 p-4 rounded-lg text-red-300 text-center">Você não tem permissão para acessar esta área.</div>
          ) : pendingRequests.length === 0 ? (
            <div className="text-center py-10 text-slate-500"><CheckCircle2 className="w-12 h-12 mx-auto mb-2 text-slate-600" /> Nenhuma solicitação pendente.</div>
          ) : (
             <div className="space-y-4">
                {pendingRequests.map((req, idx) => {
                   // Identify Type and Subtype
                   const isPoi = req.placa === 'POI';
                   let poiSubtype = '';
                   let displayName = req.modelo;

                   // SVG inline por tipo — evita Illegal Constructor do lucide no Android
                   const getPOISvg = (type: string) => {
                       switch(type) {
                           case 'FOOD': return `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 2v7c0 1.1.9 2 2 2h4a2 2 0 0 0 2-2V2"/><path d="M7 2v20"/><path d="M21 15V2v0a5 5 0 0 0-5 5v6c0 1.1.9 2 2 2h3Zm0 0v7"/></svg>`;
                           case 'BATHROOM': return `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6 6.5 3.5a1.5 1.5 0 0 0-1-.5C4.683 3 4 3.683 4 4.5V17a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5"/><line x1="10" x2="8" y1="5" y2="7"/><line x1="2" x2="22" y1="12" y2="12"/></svg>`;
                           case 'FUEL': return `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="3" x2="15" y1="22" y2="22"/><line x1="4" x2="14" y1="9" y2="9"/><path d="M14 22V4a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v18"/><path d="M14 13h2a2 2 0 0 1 2 2v2a2 2 0 0 0 2 2h0a2 2 0 0 0 2-2V9.83a2 2 0 0 0-.59-1.42L18 5"/></svg>`;
                           case 'NO_ZONA_AZUL': return `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><rect width="18" height="18" x="3" y="3" rx="2"/><path d="M9 17V7h4a3 3 0 0 1 0 6H9"/></svg>`;
                           case 'GARAGE': return `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M3 9.5V20a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1V9.5"/><path d="M21 8 12 3 3 8"/></svg>`;
                           default: return `<svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z"/><circle cx="12" cy="10" r="3"/></svg>`;
                       }
                   };

                   if (isPoi) {
                       if (req.modelo.includes(':')) {
                           const parts = req.modelo.split(':');
                           poiSubtype = parts[0].trim();
                           displayName = parts.slice(1).join(':').trim();
                       }
                   }

                   // Visual Styles based on Type
                   const cardBorderColor = isPoi ? 'border-emerald-500/30' : 'border-blue-500/30';
                   const badgeColor = isPoi ? 'bg-emerald-500/20 text-emerald-300' : 'bg-blue-500/20 text-blue-300';
                   const iconBg = isPoi ? 'bg-emerald-900/40' : 'bg-blue-900/40';
                   const titlePrefix = isPoi ? 'Ponto de Interesse' : 'Novo Veículo';

                   return (
                   <div key={idx} className={`bg-slate-900 p-0 rounded-lg border ${cardBorderColor} shadow-md overflow-hidden flex flex-col`}>
                      
                      {/* Header with Visual Distinction */}
                      <div className={`p-3 flex justify-between items-center ${isPoi ? 'bg-emerald-900/10' : 'bg-blue-900/10'} border-b ${cardBorderColor}`}>
                          <div className="flex items-center gap-2">
                              <span className={`text-[10px] font-bold px-2 py-1 rounded flex items-center gap-1 ${badgeColor}`}>
                                  {isPoi
                                    ? <span dangerouslySetInnerHTML={{ __html: getPOISvg(poiSubtype) }} />
                                    : <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M2 12h12"/></svg>
                                  }
                                  {isPoi ? (poiSubtype || 'MAPA') : 'FROTA'}
                              </span>
                              <span className="text-xs text-slate-400 font-medium uppercase tracking-wide">{titlePrefix}</span>
                          </div>
                          <div className="flex items-center gap-2">
                                <div className="bg-orange-900/20 text-orange-400 text-[10px] px-2 py-0.5 rounded border border-orange-900/30 flex items-center gap-1">
                                    <Loader2 className="w-3 h-3 animate-spin" /> Pendente
                                </div>
                                <button 
                                    onClick={() => handleEditRequest(req)}
                                    className="text-slate-400 hover:text-white p-1 rounded hover:bg-slate-800 transition-colors"
                                    title="Editar antes de aprovar"
                                >
                                    <Edit className="w-4 h-4" />
                                </button>
                          </div>
                      </div>

                      <div className="p-4 flex flex-col gap-4">
                         {/* Main Content */}
                         <div className="flex flex-col sm:flex-row gap-4">
                             <div className="flex-grow">
                                 <div className="flex items-start justify-between">
                                     <div>
                                         <h4 className="font-bold text-white text-lg">{displayName}</h4>
                                         {!isPoi && <div className="mt-1 inline-block bg-slate-800 px-2 py-0.5 rounded text-sm font-mono text-blue-200 border border-slate-700">{req.placa}</div>}
                                     </div>
                                     <div className={`p-2 rounded-full ${iconBg}`}>
                                          {isPoi
                                            ? <span dangerouslySetInnerHTML={{ __html: getPOISvg(poiSubtype).replace('width="12" height="12"', 'width="20" height="20"') }} className="text-emerald-400" />
                                            : <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-blue-400"><path d="M19 17h2c.6 0 1-.4 1-1v-3c0-.9-.7-1.7-1.5-1.9C18.7 10.6 16 10 16 10s-1.3-1.4-2.2-2.3c-.5-.4-1.1-.7-1.8-.7H5c-.6 0-1.1.4-1.4.9l-1.4 2.9A3.7 3.7 0 0 0 2 12v4c0 .6.4 1 1 1h2"/><circle cx="7" cy="17" r="2"/><circle cx="17" cy="17" r="2"/><path d="M2 12h12"/></svg>
                                          }
                                     </div>
                                 </div>
                                 
                                 <div className="mt-3 space-y-2">
                                    <div className="flex items-start gap-2 text-sm text-slate-400 bg-slate-950/30 p-2 rounded">
                                        <MapPin className="w-4 h-4 text-slate-500 shrink-0 mt-0.5" />
                                        <span>{req.endereco}</span>
                                    </div>
                                    <div className="flex items-center gap-2 text-xs text-slate-500 font-mono pl-1">
                                        <LocateFixed className="w-3 h-3" /> 
                                        {req.lat.toFixed(6)}, {req.lon.toFixed(6)}
                                    </div>
                                 </div>

                                 <a 
                                    href={`https://www.google.com/maps/search/?api=1&query=${req.lat},${req.lon}`}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="mt-3 inline-flex items-center gap-2 text-xs font-medium text-blue-400 hover:text-blue-300 transition-colors border border-blue-900/50 bg-blue-900/20 px-3 py-2 rounded-lg w-fit"
                                 >
                                    <ExternalLink className="w-3 h-3" />
                                    Conferir no Google Maps
                                 </a>

                                 <p className="text-xs text-slate-600 mt-3 italic">
                                    Sugerido por: <span className="text-slate-500">{req.user_email || 'Anônimo'}</span>
                                 </p>
                             </div>

                             {/* Map Preview */}
                             <div className="w-full sm:w-32 shrink-0">
                                 <MiniMapPreview lat={req.lat} lon={req.lon} />
                             </div>
                         </div>
                      </div>
                      
                      {/* Action Footer */}
                      <div className="flex border-t border-slate-800 divide-x divide-slate-800">
                          <button 
                            onClick={() => handleReject(req)} 
                            className="flex-1 bg-slate-900 hover:bg-red-900/20 text-slate-400 hover:text-red-400 py-3 text-sm font-bold flex items-center justify-center gap-2 transition-colors"
                          >
                              <XCircle className="w-4 h-4" /> Recusar
                          </button>
                          <button 
                            onClick={() => handleApprove(req)} 
                            className="flex-1 bg-slate-900 hover:bg-green-900/20 text-slate-300 hover:text-green-400 py-3 text-sm font-bold flex items-center justify-center gap-2 transition-colors"
                          >
                              <CheckCircle2 className="w-4 h-4" /> Aprovar
                          </button>
                      </div>
                   </div>
                )})}
             </div>
          )}
        </div>
      )}

      {isConfirming && (
        <div className="fixed inset-0 bg-black/70 z-[2000] flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in">
           <div className="bg-slate-800 p-6 rounded-2xl border border-slate-700 shadow-2xl max-w-sm w-full">
              <div className="flex flex-col items-center text-center mb-6"><div className="bg-orange-900/30 p-3 rounded-full mb-4"><HelpCircle className="w-8 h-8 text-orange-500" /></div><h3 className="text-xl font-bold text-white mb-2">Confirmar Envio?</h3><p className="text-slate-400 text-sm">Este local aparecerá no mapa como "Sugerido" até que um administrador aprove.</p></div>
              <div className="flex gap-3"><button onClick={() => setIsConfirming(false)} className="flex-1 bg-slate-700 hover:bg-slate-600 text-white font-medium py-2.5 rounded-lg transition-colors">Cancelar</button><button onClick={finalizeSuggestion} disabled={isSending} className="flex-1 bg-orange-600 hover:bg-orange-700 disabled:opacity-50 text-white font-bold py-2.5 rounded-lg transition-colors flex items-center justify-center gap-2">{isSending ? <Loader2 className="w-5 h-5 animate-spin" /> : 'Confirmar'}</button></div>
           </div>
        </div>
      )}

      {carToDelete && (
        <div className="fixed inset-0 bg-black/70 z-[2000] flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in">
           <div className="bg-slate-800 p-6 rounded-2xl border border-slate-700 shadow-2xl max-w-sm w-full">
              <div className="flex flex-col items-center text-center mb-6"><div className="bg-red-900/30 p-3 rounded-full mb-4"><Trash2 className="w-8 h-8 text-red-500" /></div><h3 className="text-xl font-bold text-white mb-2">Excluir Veículo?</h3><p className="text-slate-400 text-sm">Tem certeza que deseja remover o veículo <strong>{carToDelete.modelo} ({carToDelete.placa})</strong> da frota oficial?</p></div>
              <div className="flex gap-3"><button onClick={() => setCarToDelete(null)} className="flex-1 bg-slate-700 hover:bg-slate-600 text-white font-medium py-2.5 rounded-lg transition-colors">Cancelar</button><button onClick={finalizeCarDeletion} className="flex-1 bg-red-600 hover:bg-red-700 text-white font-bold py-2.5 rounded-lg transition-colors shadow-lg">Excluir</button></div>
           </div>
        </div>
      )}

      {(carToEdit || requestToEdit) && (
         <div className="fixed inset-0 bg-black/70 z-[2000] flex items-center justify-center p-4 backdrop-blur-sm animate-fade-in">
            <div className="bg-slate-800 p-6 rounded-2xl border border-slate-700 shadow-2xl max-w-md w-full">
               <div className="flex justify-between items-center mb-4 border-b border-slate-700 pb-2">
                   <h3 className="text-lg font-bold text-white flex items-center gap-2">
                       <Edit className="w-5 h-5 text-blue-500" /> 
                       {requestToEdit ? 'Editar Solicitação' : 'Corrigir Localização'}
                   </h3>
                   <button onClick={() => { setCarToEdit(null); setRequestToEdit(null); }} className="text-slate-400 hover:text-white"><XCircle className="w-6 h-6" /></button>
               </div>
               
               <p className="text-slate-400 text-sm mb-4">
                   {requestToEdit 
                     ? `Corrija o endereço para a sugestão de ${requestToEdit.modelo}.` 
                     : `Atualize o endereço para o veículo ${carToEdit?.placa}.`
                   } O sistema buscará as novas coordenadas automaticamente.
               </p>
               
               <div className="space-y-4">
                  <div><label className="block text-sm font-medium text-slate-400 mb-1">Novo Endereço</label><input type="text" value={editAddress} onChange={(e) => setEditAddress(e.target.value)} className="w-full bg-slate-900 border border-slate-600 rounded-lg p-3 text-white focus:ring-2 focus:ring-blue-500 outline-none" placeholder="Ex: Av. Paulista, 1000 - Bela Vista" /></div>
                  <button onClick={saveLocationUpdate} disabled={isUpdatingLocation || !editAddress.trim()} className="w-full bg-blue-600 hover:bg-blue-700 disabled:opacity-50 text-white font-bold py-3 rounded-lg flex items-center justify-center gap-2 transition-colors shadow-lg">{isUpdatingLocation ? <Loader2 className="w-5 h-5 animate-spin" /> : <CheckCircle2 className="w-5 h-5" />} Salvar Correção</button>
               </div>
            </div>
         </div>
      )}

      {/* ── Modal de Confirmação GPS ── */}
      {showGpsConfirm && gpsDetectedAddress && (
        <div className="fixed inset-0 z-[9999] bg-black/70 backdrop-blur-sm flex items-end sm:items-center justify-center p-4">
          <div className="bg-slate-900 border border-emerald-500/40 rounded-2xl p-6 w-full max-w-sm shadow-2xl shadow-emerald-900/30 animate-fade-in">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-emerald-500/20 rounded-xl">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#34d399" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><line x1="2" x2="5" y1="12" y2="12"/><line x1="19" x2="22" y1="12" y2="12"/><line x1="12" x2="12" y1="2" y2="5"/><line x1="12" x2="12" y1="19" y2="22"/><circle cx="12" cy="12" r="7"/><circle cx="12" cy="12" r="3"/></svg>
              </div>
              <div>
                <p className="text-white font-bold text-base">GPS Detectou:</p>
                <p className="text-xs text-slate-400">Confirme se a rua está correta</p>
              </div>
            </div>

            <div className="bg-slate-800 border border-slate-700 rounded-xl p-4 mb-5">
              <p className="text-emerald-300 font-semibold text-sm leading-relaxed">{gpsDetectedAddress}</p>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => { setShowGpsConfirm(false); setGpsDetectedAddress(null); setGpsCoords(null); }}
                className="flex-1 bg-slate-800 hover:bg-slate-700 text-slate-300 font-semibold py-3 rounded-xl border border-slate-700 transition-colors text-sm"
              >
                Não, recusar
              </button>
              <button
                onClick={confirmGpsLocation}
                className="flex-1 bg-emerald-600 hover:bg-emerald-500 text-white font-bold py-3 rounded-xl transition-colors text-sm flex items-center justify-center gap-2 shadow-lg shadow-emerald-900/30"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M20 6 9 17l-5-5"/></svg>
                Sim, confirmar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
